export enum RouteOrigin {
  Wizard = "Wizard",
  DetailsAction = "DetailsAction",
  Edit = "Edit",
  ClaimSubmission = "ClaimSubmission",
}
